

















import Component from "vue-class-component";
import Vue from "vue";
import { Prop } from "vue-property-decorator";

@Component({})
export default class FormButtons extends Vue {
  @Prop({ default: false }) submitting!: boolean;
  @Prop({ default: false }) submittingDisabled!: boolean;
  @Prop({ default: false }) hideGoBackButton!: boolean;
}
